import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove static SEO fallback content once React boots (for all routes, not just "/")
const seoFallback = document.getElementById("seo-fallback");
if (seoFallback) seoFallback.remove();

createRoot(document.getElementById("root")!).render(<App />);
